import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import SubmitButton from '../../../common/buttons/SubmitButton'
import ButtonLink from '../../../common/buttons/ButtonLink'


const AuthenticatedJoinWaitlistButton = ({ onJoinButtonClick }) => {
  const { t } = useTranslation()
  const course = useSelector(state => state.programPresentation.course)
  const isJoinActionLoading = useSelector(state => state.programPresentation.isJoinActionLoading)
  const currentUser = useSelector(state => state.user.current_user)

  if (!course || !currentUser) {
    return null
  }

  const notTheOnlyFamilyMember = currentUser.family?.users && currentUser.family.users.length > 1
  const alreadyJoined = course.waitlistedStudents?.some(student => student.id === currentUser.id)
  const isButtonDisabled = !(currentUser.family_admin && notTheOnlyFamilyMember) && alreadyJoined

  return (
    <SubmitButton
      onClick={(e) => course.previewMode ? e.preventDefault() : onJoinButtonClick()}
      buttonMessage={isButtonDisabled ? t('programs.landing.joinWaitlist.waitlisted') : t('programs.landing.joinWaitlist.joinTheWaitlist')}
      buttonColor={isButtonDisabled ? 'navy-button' : 'orange-button'}
      loading={isJoinActionLoading}
      disabled={isButtonDisabled}
    />
  )
}

AuthenticatedJoinWaitlistButton.propTypes = {
  onJoinButtonClick: PropTypes.func,
}

const JoinWaitlistButton = ({ onJoinButtonClick }) => {
  const { t } = useTranslation()
  const location = useLocation()
  const currentUser = useSelector(state => state.user.current_user)
  const course = useSelector(state => state.programPresentation.course)

  const rememberLocation = () => localStorage.setItem('redirectUrl', location.pathname + location.search)

  return currentUser ? (
    <AuthenticatedJoinWaitlistButton onJoinButtonClick={onJoinButtonClick} />
  ) : (
    <ButtonLink
      navigateTo='/'
      onClick={(e) => course.previewMode ? e.preventDefault() : rememberLocation()}
    >
      {t('programs.landing.joinWaitlist.joinTheWaitlist')}
    </ButtonLink>
  )
}

JoinWaitlistButton.propTypes = {
  onJoinButtonClick: PropTypes.func,
}

export default JoinWaitlistButton
